<template>
  <div>

      <section class="main-content">
          <div class="main-block">
              <div class="container">

                  <div class="bck-index bck-articles">
                      <h3 class="title sr-only"><span>會員註冊</span></h3>
                      <div class="row">
                          <div class="col-lg-4 col-md-6 col-sm-8 offset-lg-4 offset-md-3 offset-sm-2">
                              <button type="button" @click="login" class="btn btn-fb btn-block">透過 Facebook 註冊</button>
                          </div>
                          <div class="col-lg-4 col-md-6 col-sm-8 offset-lg-4 offset-md-3 offset-sm-2">

                              <form class="register-form">
                                  <h4 class="title text-center">一般註冊</h4>
                                  <div class="form-group">
                                      <label for="name" class="control-label sr-only">姓名</label>
                                      <input type="text" class="form-control" :disabled="fblogin == 1" placeholder="姓名" v-model="name">
                                  </div>
                                  <div class="form-group">
                                      <label for="email" class="control-label sr-only">信箱Email</label>
                                      <input type="email" class="form-control" :disabled="fblogin == 1" placeholder="請填寫 Email 即為您的帳號"  v-model="email">
                                  </div>
                                  <div class="form-group">
                                      <label for="password" class="control-label sr-only">密碼</label>
                                      <input type="password" class="form-control" placeholder="請輸入密碼" v-model="password">
                                  </div>
                                  <div class="form-group">
                                      <label for="password" class="control-label sr-only">再輸入一次密碼</label>
                                      <input type="password" class="form-control" placeholder="再輸入一次密碼" v-model="password2">
                                  </div>
                                  <div class="form-group">
                                      <div class="checkbox">
                                          <label>
                                              <input type="checkbox" value="1" v-model="agreement">
                                              我同意<a class="articles-txt-link" href="/privacy" target="_blink">「會員服務使用條款及個人資料提供書」</a>的內容
                                          </label>
                                      </div>
                                  </div>
                                  <div class="form-group">
                                      <button type="button" @click="register" class="btn btn-primary btn-block">註冊</button>
                                  </div>
                              </form>

                          </div>
                      </div>
                  </div>

              </div>
          </div>
      </section>


  </div>
</template>

<script>
/* eslint-disable */
import {mapActions, mapGetters} from 'vuex'
import Qs from 'qs'
export default {
  name: 'register',
  data () {
    return {
      uri: this.$store.getters.getUri,
      name: '',
      email: '',
      password: '',
      password2: '',
      app_id: '',
      agreement: '',
      fblogin: 0
    }
  },
  computed: {
    ...mapGetters([
      'getUri',
      'getTestUri'
    ])
  },
  mounted: function () {
    let vm = this
    window.fbAsyncInit = function() {
      FB.init({
        appId      : '1903095033298686',
        cookie     : true,
        xfbml      : true,
        version    : 'v2.8'
      })
      FB.AppEvents.logPageView()
    }
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ]),
    getProfile () {
      let vm = this
      FB.api('/me?fields=name,id,email', function (response) {
        // console.log(response)
        vm.$set(vm, 'name', response.name)
        vm.$set(vm, 'email', response.email)
        vm.$set(vm, 'app_id', response.id)
      })
    },
    login () {
      let vm = this
      FB.login(function (response) {
        vm.statusChangeCallback(response) 
      }, {
        scope: 'email, public_profile',
        return_scopes: true
      })
      this.fblogin =1
    },
    statusChangeCallback (response) {
      let vm = this
      console.log(response)
      if (response.status === 'connected') {
        vm.getProfile()
      }
    },
    register () {
      let str = ''
      // console.log(this.UserID)
      if (this.name === '') {
        str += '請填寫個人姓名。\n'
      } else if (this.email === '' || typeof this.email === 'undefined') {
        str += '請輸入您的信箱\n'
      } else if (this.password === '' || typeof this.password === 'undefined') {
        str += '請輸入您的密碼\n'
      } else if (this.password !== this.password2) {
        str += '您兩次輸入的密碼不同，請再次輸入。\n'
      } else if (this.agreement === '') {
        str += '請勾選個人隱私權條款。\n'
      }
      if (str === '') {
        let data = Qs.stringify({
          name: this.name,
          email: this.email,
          password: this.password,
          app_id: this.app_id
        })
        this.$http.post(this.uri + 'User/fbRegister', data)
        .then(function (res) {
          let data = res.data
          console.log(data)
          if (data.status === 200) {
            window.alert('註冊成功')
          } else if(data.status === 512) {
            window.alert('帳號註冊失敗。')
          } else if(data.status === 513) {
            window.alert('註冊失敗，請填寫完整資料。')
          } else if(data.status === 511) {
            window.alert('此帳號已經被註冊過。')
          }
          this.$router.go('/')
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        window.alert(str)
        return false
      }
    }  
  }
}
</script>



// WEBPACK FOOTER //
// Register.vue?3cbcacfc